import React from "react";
import { Check, Copy } from "lucide-react";
import * as Sentry from "@sentry/react";

interface Props {
  narrative: string;
}

export const RightSidebarNarrativeCopy: React.FC<Props> = ({ narrative }) => {
  const [copiedConversation, setCopiedConversation] = React.useState(false);
  const copyConversation = React.useCallback(async () => {
    try {
      await navigator.clipboard.writeText(narrative);
      setCopiedConversation(true);
      setTimeout(() => setCopiedConversation(false), 2000);
    } catch (error) {
      Sentry.captureException(error);
    }
  }, [narrative]);

  return (
    <div className="mb-2 flex justify-end space-x-2">
      <button
        onClick={copyConversation}
        className="mb-3 flex items-center rounded bg-white px-3 py-1 text-xs text-gray-500 transition-colors duration-200 hover:text-gray-700"
      >
        {copiedConversation ? <Check size={16} className="mr-1 text-green-500" /> : <Copy size={16} className="mr-1" />}
        {copiedConversation ? "Copied" : "Copy"}
      </button>
    </div>
  );
};
